import type React from 'react';

import ArrowButton from '@components/shared/arrowButton';
import OpenVerktoyButtons, { ButtonsVisibility } from '@components/verktoy-details/components/buttons/open-verktoy-buttons';
import LaunchUserInfoMineVerktoy from '@components/verktoy-details/components/info/launch-userinfo-mineverktoy';

import type { useGetResources } from '@hooks/useGetResources';
import type { LenkeType, MittVerktoyItem } from '@src/types/minhelseentities';
import type { StartVerktoyParams } from '@src/types/startVerktoyParams';

import styles from '../entry-page/styles/mine-verktoy-preview.module.scss';

interface VerktoyActionsProps {
  verktoy: MittVerktoyItem;
  showOpenVerktoy: boolean;
  openVerktoyButtonRef: React.RefObject<HTMLButtonElement>;
  startVerktoy: (params: StartVerktoyParams) => void;
  visVerktoyDetaljer: (verktoyId: string) => void;
  resources: ReturnType<typeof useGetResources>;
}

const VerktoyActions: React.FC<VerktoyActionsProps> = ({
  verktoy,
  showOpenVerktoy,
  openVerktoyButtonRef,
  startVerktoy,
  visVerktoyDetaljer,
  resources,
}) => {
  if (verktoy.ErVerktoyTilgjengelig === false) {
    return <LaunchUserInfoMineVerktoy erLaeringsaktivitet={true} verktoy={verktoy} />;
  }
  if (showOpenVerktoy && verktoy.Lenker) {
    return (
      <OpenVerktoyButtons
        className={styles.elementMarginTop}
        verktoyLenker={verktoy.Lenker}
        buttonRef={openVerktoyButtonRef}
        startVerktoy={(lenkeType: LenkeType) =>
          startVerktoy({
            lenker: verktoy.Lenker,
            lenkeType: lenkeType,
            laeringsaktivtetId: verktoy.LaeringsaktivitetId,
            oppstartsType: verktoy.OppstartType,
            kanStartesAvInnloggetBruker: verktoy.KanStartesAvInnloggetBruker,
            verktoyId: verktoy.VerktoyId,
            verktoyNavn: verktoy.VerktoyNavn,
            interntVerktoy: verktoy.InterntVerktoy,
          })
        }
        showArrowIcon={true}
        visibility={ButtonsVisibility.ShowWebOnly}
      />
    );
  }
  return (
    <ArrowButton
      className={`${styles.buttonVisMerInfo} ${styles.elementMarginTop}`}
      onClick={() => visVerktoyDetaljer(verktoy.VerktoyId)}
      text={resources?.vis_mer_info_om_verktoyet ?? ''}
    />
  );
};

export default VerktoyActions;
